// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DTMT","question":"styles_question__2LVOT","description":"styles_description__cpbJK"};